import { Component } from 'react';
//import Home from './Components/rah-kala/Home';
import Home from './Components/tarabar/Home';
import 'devextreme/dist/css/dx.light.css';
import notify from 'devextreme/ui/notify';
import './App.css';
import SideDivider from './Components/layout/SideDivider';
import StepCounter from './Components/utils/StepCounter';

class App extends Component {
  constructor(prp) {
    super(prp);
    console.log('location = ', document.location?.href);

    window.notif = msg => {
      notify({
        message: msg, //Array.isArray(msg) ? msg.reduce((a, b) => a + ' ' + b) : msg,
        // height: 45,
        width: 350,
        // minWidth: 150,
        type: 'info',
        displayTime: 5000,
        rtlEnabled: true
      }, {
        position: 'bottom left',
        direction: 'up-stack',
      });
      console.log('>- NOTIFY: ', msg);
      //Array.isArray(msg) ? console.log('>- NOTIFY: ', ...msg) : console.log('>- NOTIFY: ', msg);
    }

    //window.bodyHistory = [];

    window.reload = () => this.setState({ key: this.state.key + 1 });

    window.setFullBody = (component, whenDone, thenSaveToHistory) => {
      this.state.innerBody = undefined;

      this.setState({ fullBody: component, fullBodyKey: this.state.fullBodyKey + 1 }, whenDone);
    };

    window.forceReloadAfterMenuItemClicked = true;

    window.setMode = (mode, forceReload = window.forceReloadAfterMenuItemClicked) => forceReload
      ? this.setState({ mode, innerBodyKey: 1 + (this.state.innerBodyKey ?? 0) })
      : this.setState({ mode });

    window.setInnerBody = (component, whenDone, thenSaveToHistory) => {
      this.state.fullBody = undefined;
      //window.uniPage?.saveStates?.();
      //SideDivider.innerBody = component;

      // if (thenSaveToHistory) {
      //   while (window.bodyHistory.length >= historySize)
      //     window.bodyHistory = window.bodyHistory.splice(1);

      //   window.bodyHistory.push(component);
      //   window.historyIndex = window.bodyHistory.length - 1;
      // }
      //console.log('setInnerBody');

      this.setState({ innerBody: component, innerBodyKey: this.state.innerBodyKey + 1 }, whenDone);
      //SideDivider.innerBodyRef?.forceUpdate?.();
    };

    window.setOrdersFilter = (mode, status, statusName, whenDone) => this.setState({ mode, status, statusName, bodyKey: this.state.bodyKey + 1 }, whenDone);
  }

  state = {
    innerBodyKey: 1,
    fullBodyKey: 1,
    serverIsConnected: false,
    innerBody: null,
    bodyKey: 1,
    mode: '', // 'missions',
    status: '',
    key: 1,
  };

  componentDidMount() {
    window.user = { id: 0 };
  }

  render() {
    console.log('>> App.jsx state=', this.state, ' user=', window.user, 'config=', window.config);

    return (
      this.state.fullBody ??
      <Home innerBody={this.state.innerBody}
        key={`home_${this.state.key}_${this.state.innerBodyKey}_${this.state.mode}`}
        bodyKey={`${this.state.bodyKey}_${this.state.mode}`}
        mode={this.state.mode}
        status={this.state.status}
        statusName={this.state.statusName ?? ''}
      />
    );
  }
}

export default App;
